import * as React from 'react';
import { translate, WithNamespaces } from 'react-i18next';

import { translationNameSpaces } from 'constants/app.constants';
import { TEXT_KEYS } from './app-title.constants';

export class AppTitle extends React.Component<WithNamespaces> {
    constructor(props: WithNamespaces) {
        super(props);

        this.setTitle();
        this.props.i18n.on('languageChanged', this.setTitle);
    }

    public componentWillUnmount() {
        this.props.i18n.off('languageChanged', this.setTitle);
    }

    public render(): JSX.Element | null {
        return null;
    }

    private setTitle = (): void => {
        const { t: translateKey } = this.props;
        const gameName: string = translateKey(TEXT_KEYS.GAME_NAME);
        document.title = translateKey(TEXT_KEYS.APP_TITLE_TEXT, { gameName });
    };
}

export default translate(translationNameSpaces)(AppTitle);
